import { render, staticRenderFns } from "./Room3.vue?vue&type=template&id=3b45a7f6&scoped=true&"
import script from "./Room3.vue?vue&type=script&lang=ts&"
export * from "./Room3.vue?vue&type=script&lang=ts&"
import style0 from "./Room3.vue?vue&type=style&index=0&id=3b45a7f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b45a7f6",
  null
  
)

export default component.exports